export default "__VITE_ASSET__5d670fbc__"